export const COLOR_PRESETS = [
    '#FCCB1A', '#ffffff', '#a6ccf5', '#fff9b1', '#ffcee0',
    '#d5f692', '#93d275', '#f5f6f8', '#e5e6e8', '#333333'
]
